let context = null;

const isInternalReferrer = (referrer) => {
  if (!referrer) {
    return false;
  }

  try {
    const referrerUrl = new URL(referrer);
    const mainDomain = context.$helpers.getMainDomain();

    // Extract main domain from referrer using same logic as getMainDomain
    const referrerHostname = referrerUrl.hostname;
    const parts = referrerHostname.split(".");
    while (parts.length > 2) {
      parts.shift();
    }
    const referrerMainDomain = parts.join(".");

    // Compare main domains
    return referrerMainDomain === mainDomain;
  } catch {
    // If URL parsing fails, treat as internal to be safe
    return true;
  }
};

const saveUtmParameters = function (
  source,
  medium,
  campaign,
  content,
  term,
  adgroup
) {
  let campaigns = JSON.parse(context.$cookie.get("campaigns") || null);

  if (!campaigns) {
    campaigns = [];
  }

  if (
    campaigns.length === 0 ||
    campaigns[campaigns.length - 1].source !== source ||
    campaigns[campaigns.length - 1].medium !== medium ||
    campaigns[campaigns.length - 1].campaign !== campaign ||
    campaigns[campaigns.length - 1].content !== content ||
    campaigns[campaigns.length - 1].term !== term ||
    campaigns[campaigns.length - 1].adgroup !== adgroup
  ) {
    campaigns.push({
      timestamp: new Date().getTime(),
      source,
      medium,
      campaign,
      content,
      term,
      adgroup,
    });

    let domain = "." + context.$helpers.getMainDomain();

    if (domain === ".localhost") {
      domain = "";
    }

    context.$cookie.set("campaigns", JSON.stringify(campaigns), {
      maxAge: 365,
      path: "/",
      domain,
    });
  }
};

const checkUtmParameters = (route) => {
  const source = route?.query?.utm_source ?? "";
  const medium = route?.query?.utm_medium ?? "";
  const campaign = route?.query?.utm_campaign ?? "";
  const content = route?.query?.utm_content ?? "";
  const term = route?.query?.utm_term ?? "";
  const adgroup = route?.query?.utm_adgroup ?? "";

  // If any UTM parameters exist, use them (existing behavior)
  if (source || medium || campaign || content || term || adgroup) {
    saveUtmParameters(source, medium, campaign, content, term, adgroup);
  } else {
    // No UTM parameters - check referrer to determine source
    const referrer = document.referrer;

    if (!referrer) {
      return;
    }

    // Skip if internal navigation
    if (isInternalReferrer(referrer)) {
      return;
    }

    // Save the referrer as source
    saveUtmParameters(
      referrer,
      "", // no medium
      "", // no campaign
      "", // no content
      "", // no term
      "" // no adgroup
    );
  }
};

export default (ctx) => {
  window.onNuxtReady(() => {
    context = ctx;
    checkUtmParameters(ctx.route);
  })
};
